import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppService } from './core/services/app.service';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './modules/shared/sidebar/components/sidebar.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, SidebarComponent, RouterOutlet, NgxUiLoaderModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit 
{
  title = 'Prosegur Certificados';
  menuOpen = false;
  version_back: string;
  version_front: string;
  year: number = new Date().getFullYear();
  roleTitle: string = '';

  constructor( translate: TranslateService, public appService: AppService, public router: Router, private cdr: ChangeDetectorRef) 
  {
    const userInfo = JSON.parse(sessionStorage.getItem(environment.userStorage));
    if (userInfo)
    {
      switch(userInfo.languagesid)
      {
        case 1:
          translate.use('es');
          break;
        case 2:
          translate.use('en');
          break;
        case 3:
          translate.use('bz');
          break;
        default:
            break;
      }
    }
    else { translate.setDefaultLang('en'); translate.use('en'); }
  }

  ngOnInit() 
  { 
    this.version_front = environment.version;
    this.version_back = this.appService.getFromLocal('version');
    this.appService.title$.subscribe(title => { this.roleTitle = title; this.cdr.markForCheck(); });
  }

  isLoggedOrLogin() 
  {
    if (this.router.url === '/login') { return false }
    if (!this.appService.isLogged) { this.appService.checkLogged(); }
    return this.appService.isLogged && this.router.url !== '/login';
  }

  hideContent() { return this.appService.hideContentOnLogOut; }
  isLogged() 
  {
    if (!this.appService.isLogged) { this.appService.checkLogged(); }
    return this.appService.isLogged;
  }
  toggle() { this.menuOpen = true; }
  close() { this.menuOpen = false; }
}
